export class Dataset {
  constructor(public name: string, readonly type: string = null, readonly meta: any = null) {}

  get displayName() {
    return Object.get(this.meta, 'display.name') || this.name.replace(/_/g, ' ').titleize()
  }
}
